<div class="main-content">
  <div class="game-page" style="position: relative;">
    <!-- Nav tabs -->

    <tabset>
      <tab heading="ODDS">
        <div *ngIf="data">
          <div class="tab-content">
            <div id="odds" class="tab-pane active">
              <div class="match-title">
                <span class="match-name">{{(data?.event?.event?.event_type_id == '7')?'HR -
                  ':(data?.event?.event?.event_type_id == '4339')?'GR -':''}}{{data?.event?.event?.name}}</span>
                <span class="float-right">
                  <span
                    *ngIf="events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.market_start_time
                    | date : 'dd/MM/YYYY HH:mm:ss'}}</span>
                  <span
                    *ngIf="!events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.open_date |
                    date : 'dd/MM/YYYY HH:mm:ss'}}</span>
                </span>
              </div>
              <div class=""
                *ngIf="!isLoginWithDemo() && isLogin() && data?.event?.event?.category == events_category?.virtual">
                <iframe class="LiveStream-video-col" id="tvStr" [src]='iframeURL | safeURL'>
                </iframe>
              </div>

              <div *ngIf="isLogin()" class="" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
                <div id="tv-block-id-mob" class="embed-responsive embed-responsive-16by9">
                  <iframe *ngIf="data && data.event?.event?.tv_provider != 'flash'" [src]='iframeURL | safeURL' class="LiveStream-video-col"></iframe>
                </div>
                <!-- <div *ngIf="tvLoad" style="min-height: 100px;background: #000;color: #fff;font-size: 20px;display: flex;justify-content: center;align-items: center;"> Loading...</div> -->
              </div>

              <!-- score table -->
              <div id="scoreboard-box">
                <div style="margin-bottom: 3px;" class="scorecard scorecard-mobile" *ngIf="scoreHtml != ''"
                  [innerHTML]="scoreHtml | safeHtml"></div>
              </div>
              <!-- /score table -->

              <!-- horse -->

              <!-- MATCH_ODDS -->
              <div *ngIf="data?.event?.match_odds?.status == 1">
                <!-- <div class="market-title mt-1">
                  MATCH_ODDS
                  <button class="btn-cashout" *ngIf="data?.event?.match_odds?.runners.length == 2" (click)="cashOut(data?.event?.match_odds, 'match_odds')">cashout</button>
                  <p class="float-right mb-0" (click)="openModalWithComponent('m')" ><i class="fas fa-info-circle"></i></p>
                </div> -->
                <!-- <div class="main-market"> -->

                <app-market-detail
                  [data]="{marketData: data?.event?.match_odds, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                  (betDt)="openBetPlace($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"
                  (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>

                <!-- </div> -->
                <div>
                  <!---->
                </div>
              </div>
              <!-- /MATCH_ODDS -->

              <!-- BOOKMAKER -->
              <div *ngIf="data?.event?.book_makers.length > 0">
                <div *ngFor="let bmItem of data?.event?.book_makers;let bi=index;trackBy:trackByIndex;">
                  <div *ngIf="bmItem.status == 1">
                    <!-- <div class="market-title mt-1">
                      {{bmItem?.title}}
                      <button class="btn-cashout" *ngIf="bmItem?.book_maker_odds.length == 2" (click)="cashOut(bmItem,'book_makers')">cashout</button>
                      <p class="float-right mb-0" (click)="openModalWithComponent('b')" ><i class="fas fa-info-circle"></i></p>
                    </div> -->
                    <app-bookmaker-detail
                      [data]="{marketData: bmItem, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                      (betDt)="openBetPlace($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"
                      (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-bookmaker-detail>
                  </div>
                </div>
              </div>
              <!-- /BOOKMAKER -->

              <!-- LINE -->
              <div class="fancy-markets mt-1" *ngIf="data?.event?.fancy.length > 0 && fLineMrk">
                <div class="fancy-market">
                  <div>
                    <div class="table-header">
                      <div class="market-title float-left country-name box-4">
                        <span class="text-uppercase mr-1">Line</span>
                        <p class="float-right mb-0" (click)="openModalWithComponent('f')"><i class="fas fa-info-circle"
                            data-toggle="modal" data-target="#Fancy_Rules"></i></p>
                      </div>
                      <div class="box-1 float-left lay text-center"><b>No</b></div>
                      <div class="back box-1 float-left back text-center"><b>Yes</b></div>
                    </div>
                    <app-fancy-detail
                      [data]="{fancyData: data?.event?.fancy, tabVal:allFancy, isFancy:false, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                      (betDt)="openBetPlace($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"
                      (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                  </div>
                </div>
              </div>
              <!-- /LINE -->

              <div class="fancy-markets" *ngIf="data?.event?.fancy.length > 0">

                <tabset type="tabs mt-2 fancy-nav">

                  <!-- FANCY -->
                  <tab *ngFor="let tab of fancyTab">
                    <ng-template tabHeading>
                      <span style="text-transform: uppercase;">{{getKeyName(tab.name)}}</span>
                    </ng-template>

                    <div *ngIf="!isCommon(tab.value,allFancy)">
                      <div class="fancy-market" *ngIf="tab.name == 'all'">
                        <div *ngFor="let allDt of fancyTab">
                          <div *ngIf="allDt.name != 'all' && !isCommon(allDt.value,allFancy)">
                            <div class="table-header">
                              <div class="market-title float-left country-name box-4">
                                <span class="text-uppercase mr-1">{{getKeyName(allDt.name)}}</span>
                                <p class="float-right mb-0" (click)="openModalWithComponent('f')"><i
                                    class="fas fa-info-circle" data-toggle="modal" data-target="#Fancy_Rules"></i></p>
                              </div>
                              <div class="box-1 float-left lay text-center"><b>No</b></div>
                              <div class="back box-1 float-left back text-center"><b>Yes</b></div>
                            </div>
                            <app-fancy-detail
                              [data]="{fancyData: data?.event?.fancy, tabVal:allDt.value, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                              (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                              (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="fancy-market" *ngIf="tab.name != 'all'">
                      <div>
                        <div class="table-header">
                          <div class="market-title float-left country-name box-4">
                            <span class="text-uppercase mr-1">{{getKeyName(tab.name)}}</span>
                            <p class="float-right mb-0" (click)="openModalWithComponent('f')"><i
                                class="fas fa-info-circle" data-toggle="modal" data-target="#Fancy_Rules"></i></p>
                          </div>
                          <div class="box-1 float-left lay text-center"><b>No</b></div>
                          <div class="back box-1 float-left back text-center"><b>Yes</b></div>
                        </div>
                        <app-fancy-detail
                          [data]="{fancyData: data?.event?.fancy, tabVal:tab.value, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                          (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                          (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                      </div>
                    </div>

                    <div *ngIf="isCommon(tab.value,allFancy)" class="fancy-market">
                      <div class="fancy-message col-12 mt-1">No real-time records found</div>
                    </div>
                  </tab>
                  <!-- /FANCY -->
                </tabset>

              </div>

              <!-- OTHER MARKETS -->
              <div *ngFor="let item of data?.event?.markets; let i=index; trackBy:trackByIndex;">
                <div
                  *ngIf="(item.market_type_id != 'MATCH_ODDS' && item.status != 4) && (mId == null || mId == item.market_id)"
                  [ngClass]="data?.event?.event?.event_type_id == 7 ? 'horse-market' : ''">

                  <app-market-detail *ngIf="!events.races.includes(data?.event?.event?.event_type_id)"
                    [data]="{marketData: item, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                    (betDt)="openBetPlace($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"
                    (closeBet)="closeBet($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>

                  <!-- race detail -->
                  <div *ngIf="events.races.includes(data?.event?.event?.event_type_id)">
                    <div class="market-title mt-1">
                      {{item.market_name}}
                      <!-- <button class="btn-cashout" *ngIf="item?.runners.length == 2" (click)="cashOut(item, 'match_odds')">cashout</button> -->
                      <span *ngIf="events.races.includes(data?.event?.event?.event_type_id)">
                        <button class="btn-cashout"
                          *ngIf="!item?.bet_open && raceTimer && raceTimer != ''">{{raceTimer}}</button>
                        <button class="btn-cashout"
                          *ngIf="item?.bet_open && (oddsLisDisNew[item?.market_id]?.inplay == '' || oddsLisDisNew[item?.market_id]?.inplay == 0)">Betting
                          Open</button>
                        <button class="btn-cashout" *ngIf="oddsLisDisNew[item?.market_id]?.inplay == 1">In Play</button>
                      </span>
                      <p class="float-right mb-0" (click)="openModalWithComponent('m')"><i
                          class="fas fa-info-circle"></i></p>
                    </div>
                    <div class="main-market">
                      <app-race-detail *ngIf="events.races.includes(data?.event?.event?.event_type_id)"
                        [data]="{marketData: item, event_type_id:data?.event?.event?.event_type_id, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData}"
                        (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                        (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)"></app-race-detail>
                    </div>
                  </div>
                  <!-- race detail -->
                </div>
                <div>
                  <!---->
                </div>
              </div>
              <!-- /OTHER MARKETS -->
            </div>
          </div>
        </div>

        <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>

      </tab>
      <tab heading="MATCHED BET ({{betCount}})">
        <app-m-bet-list *ngIf="isLogin()" (totalBets)="betCount = $event"></app-m-bet-list>
      </tab>
    </tabset>

    <div *ngIf="isLogin()" class="tv-icon">
      <p class="mb-0">
        <a (click)="getTvData()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic"> <i class="fas fa-tv"></i></a>
      </p>
    </div>

    <!-- Button trigger modal -->


  </div>
</div>

<div class="modal fade place-bet-modal" bsModal #betSlipModal="bs-modal" [config]="{backdrop: true}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Placebet</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeBet('')">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-m-bet-slip [data]="betSlipData" [exposLisDis]="exposLisDis" (updateData)="updateData($event)"
          (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)">
        </app-m-bet-slip>
      </div>
    </div>
  </div>
</div>